<template>
  <div class="relative bg-blue-500" style="height: calc(100vh - 175px)">

    <div class="absolute w-full text-center pin-x bottom-0 mb-8">
      <img src="/images/icon-caret-down-huge.svg" class="inline cursor-pointer jumpy" @click="scrollDown()">
    </div>

    <div class="absolute left-0 ml-6 z-10" style="top: 50%; transform: translateY(-50%);">
      <div
        class="rounded-full w-6 md:w-8 h-6 md:h-8 mb-2 hover:bg-blue-300 st-bgc cursor-pointer"
        @click="selectSlide(i - 1)"
        :class="i - 1 == currentSlideIndex ? 'bg-blue-300' : 'bg-blue-400'"
        :key="`pager-${i}`"
        v-for="i in slides.length"></div>
    </div>
    <transition name="fade" mode="out-in">
      <div
        class="flex items-center bg-center bg-cover h-full"
        :key="`slide-${i}`"
        :style="{ backgroundImage: `url('${currentSlide.image_full_url}')`}"
        v-for="(slide, i) in slides"
        v-if="i == currentSlideIndex">
        <a :href="slide.link" class="block py-4 pl-12 pr-4 link-basic flex-1 text-center leading-none text-white font-bold text-4xl md:text-6xl">{{ currentSlide.name }}</a>
      </div>
    </transition>
  </div>
</template>
<script>
export default {
  name: 'home-slider',
  props: {
    slides: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  data() {
    return {
      currentSlide: 0,
      currentSlideIndex: 0,
    }
  },
  methods: {
    selectSlide(index) {
      this.currentSlideIndex = index;
      this.currentSlide = this.slides[index];
    },
    scrollDown() {
      window.scrollTo({
        top: window.screen.height,
        left: 0,
        behavior: 'smooth'
      });
    }
  },
  mounted() {
    this.currentSlide = this.slides[0];
  },
}
</script>